// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-adobe-photoshop"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3L21 3L21 21L3 21L3 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 3L21 3L21 21L3 21L3 3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7 17L7 12M7 12L7 7L9.5 7C10.8807 7 12 8.11929 12 9.5C12 10.8807 10.8807 12 9.5 12H7ZM17 11H15.9528C15.1505 11 14.5 11.6505 14.5 12.4528C14.5 13.0782 14.9002 13.6334 15.4934 13.8311L16.5066 14.1689C17.0998 14.3666 17.5 14.9218 17.5 15.5472C17.5 16.3495 16.8495 17 16.0472 17H14.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-adobe-photoshop')
export default class LogoAdobePhotoshopIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-adobe-photoshop',
    }
  }
}
